__turbopack_context__.v({
  "fade-in": "AnimatedIconPackaging-module-scss-module__UEOrZG__fade-in",
  "root": "AnimatedIconPackaging-module-scss-module__UEOrZG__root",
});
